<template>
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center registration-form">
    <form class="form-signup" @submit.prevent="onSubmit">
      <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
      <img class="mb-4" src="../../../assets/img/marathondynamics/MDIlogo_notext.png" alt="" width="100" height="">
      <!-- <h1 class="h3 font-weight-normal" style="margin-bottom: 0;">Inscríbete a</h1> -->
      <h1 class="h3 mb-3 font-weight-normal">Create Profile</h1>
      <label for="inputEmail" class="sr-only">Email</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Email" required autofocus v-model="email">
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password">
      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div> -->
      <button class="btn btn-lg btn-mdi btn-block" type="submit">Sign Up</button>
      <!-- <p class="mt-5 mb-5 text-muted">&copy; 2017-2018</p> -->
      <p class="pt-4">Already have a profile? <router-link to="/login" class="">Log In</router-link></p>
      <!-- <p class="pt-4 pb-5 text-muted">¿Preguntas? 350-4775478</p> -->
    </form>
  </div>
</template>

<script>
  // import axios from 'axios';
  // import axios from '../axios-auth'; // Don't have to name it axios, can name it anything - Lecture 348

  export default {
    data () {
      return {
        email: '',
        password: '',
      }
    },
    methods: {
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/optimum/create-candidate/', {
        //   email: formData.email,
        //   password: formData.password,
        //   // returnSecureToken: true,
        //   agency: 2,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))

        // https://vuex.vuejs.org/guide/actions.html
        // Once the user has been registered then we log them in
        // this.$store.dispatch('registerCandidate', {email: this.email, password: this.password}).then(() => {
        this.$store.dispatch('registerUser', {email: this.email, password: this.password, user_type: 'candidate', team: 'MDI'}).then(() => {
          // this.$store.dispatch('testAction')
          // this.$store.dispatch('login', {email: this.email, password: this.password}).then(() => {
          //   this.$store.dispatch('getUser')
          // })
          console.log('Done registration')
          this.$store.dispatch('sendEmail', { subject: 'New MDI Runner Registration!',
                                              message: 'Hi Coach, a new runner has just registered!\nTheir email is: '+this.email,
                                              from: 'myrundash@gmail.com',
                                              email: 'aakashkgoel@gmail.com',
                                              reply: 'aakashkgoel@gmail.com',
                                              userID: 1})
          this.$store.dispatch('sendEmail', { subject: 'New MDI Runner Registration!',
                                              message: 'Hi Coach, a new runner has just registered!\nTheir email is: '+this.email,
                                              from: 'myrundash@gmail.com',
                                              email: 'kevinsmith@marathondynamics.com',
                                              reply: 'aakashkgoel@gmail.com',
                                              userID: 1})
        })
      }
    }
  }
</script>

<style>
/* Bootstrap sign up form */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

  .registration-form {
    height: calc(100vh - 30px); /* There is a 15px margin top and bottom */
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signup {
    width: 100%;
    max-width: 330px;
    /* min-width: 300px; */
    padding: 15px;
    margin: auto;
  }
  .form-signup .checkbox {
    font-weight: 400;
  }
  .form-signup .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signup .form-control:focus {
    z-index: 2;
  }
  .form-signup input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signup input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  @media (max-width: 768px) {
    .registration-form {
      height: auto;
      /* display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 40px; */
      padding-left: 30px;
      background-color: #f5f5f5;
      background-color: #fff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/myrundash/marathondynamics/Registration.vue